import { InjectionToken } from '@angular/core';
import { IImageryConfig } from './iimagery-config';

export const IMAGERY_CONFIG: InjectionToken<IImageryConfig> = new InjectionToken('IMAGERY_CONFIG');
